import React, {useEffect, useState, useRef} from 'react';
import '../App.css';
import Bodyheaderloged from './bodyheaderloged'
import Axios from 'axios';
import Grillasarolesadmin from './grillasarolesadmin'
import { useNavigate } from "react-router-dom";


function Bodyhomeadminroles (){    
    const navigate = useNavigate();
    const [administradores, setAdministradores] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [casinos, setCasinos] = useState([]);

    let statuscall = '' 
    

    const administradoresList = administradores.map((item, i) => 
    <option key={i} value={item.mail}>{item.nombre} {item.apellido}</option>);


    const empresasList = empresas.map((item, i) => 
    <option key={i} value={item.rut}>{item.nombre}</option>);
    
    const casinosList = casinos.map((item, i) =>
    <option key={i} value={item.id}>{item.nombre}</option>);



    const getData = async () =>
    {
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idperfil = idperfilstr.replace('"', '')

        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                id_perfil: idperfil
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            if(idperfil === "4")
            {

            }
        }).catch(error => {
            return error     
        })   
    }

    useEffect(() => {  
        getData()

    }, [])


    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheaderloged/>
            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>
                    <Grillasarolesadmin/>                                                                  
                </div>
            </div>
        </div>            
    )
}
export default Bodyhomeadminroles